import { render, staticRenderFns } from "./shai_xuan.vue?vue&type=template&id=0e3c1d68&scoped=true"
import script from "./shai_xuan.vue?vue&type=script&lang=js"
export * from "./shai_xuan.vue?vue&type=script&lang=js"
import style0 from "./shai_xuan.vue?vue&type=style&index=0&id=0e3c1d68&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3c1d68",
  null
  
)

export default component.exports